import { useStore } from "vuex"
import { computed, onMounted } from "vue"
import GetLabel from "foundation/js/getLabel"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "FrivilligeShopWrongRoleModal",
    setup(){
        const store = useStore()

        let first, close

        const tabTrap = function (e) {
            if (e.key === 'Tab' && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
                return
            }

            first.focus()
        }

        onMounted(() => {
            first = document.querySelector('.kb-button[data-order="first"]')
            close = document.querySelector('.kb-page-overlay__close')

            onTransitionendCallback(
            {
                opening() {
                    first.focus()
                }
            },
            { persistent: true }
        )
        })
        
        const url = computed(() => store.state.main.page_overlay_content_data.rolePageUrl)
        const redirect = () => {
            window.location.href = url.value
        }

        return {
            tabTrap,
            redirect,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'FrivilligeShopWrongRoleModal' }),
        }
    }
}